import classNames from 'classnames';
import IEmptyState from "EmptyState";
import AudioSystemComparisonTableItemPowerBar from "Pages/ProductPricing/AudioSystemComparisonTableItemPowerBar";
import React from 'react';

interface IAudioSystemComparisonTableItemProps {
    title: string;
    subtitle?: string;
    isBarak: boolean;
    powerValue: number;
    wattage: number;
}

export default class AudioSystemComparisonTableItem extends React.Component<IAudioSystemComparisonTableItemProps, IEmptyState> {
    constructor(props: IAudioSystemComparisonTableItemProps) {
        super(props);
        this.state = {}
    }

    public render() {
        return (
            <div className={classNames("item", {"barak": this.props.isBarak})}>
                <div className="header">
                    <div className="title">
                        {this.props.isBarak && <img src="img/logo.svg"></img>}
                        {this.props.title}
                    </div>
                    <div className="subtitle">
                        {this.props.subtitle}
                    </div>
                </div>
                <div className="content">
                    <div className="power-bars">
                        <AudioSystemComparisonTableItemPowerBar title={"Total"} value={this.props.powerValue}></AudioSystemComparisonTableItemPowerBar>
                    </div>
                    <div className="power">
                        {this.props.wattage} W
                    </div>
                </div>
            </div>
        );
    }
}